import type { ReactElement } from 'react'
import React from 'react'

import { Typography } from '@s4l/ds'

import styles from './index.module.css'

interface IAdvantageProps {
  title: string
  subtitle: string
  icon: ReactElement
}

export function Advantage(props: IAdvantageProps) {
  const { title, subtitle, icon } = props
  return (
    <div data-testid="advantage-item" className={styles.advantage}>
      <header>
        <span className={styles.title}>
          <Typography variant="body" size="xl" bold>
            {title}
          </Typography>
        </span>
        <span className={styles.iconContainer}>{icon}</span>
      </header>
      <Typography variant="body" size="m" as="footer">
        {subtitle}
      </Typography>
    </div>
  )
}
